module.exports = __webpack_public_path__ + "static/media/cricket.7844182a.png";